export default __webpack_public_path__ + "static/media/sliderMF.be23c536.png";